module.exports = "<div #player [attr.video-id]=\"episodeId\" id=\"youtube-player\"></div>\r\n"